import React from "react";

interface StatsCardsProps {
  data: any[];
  totalStats: {
    totalPartners: number;
    partnersWithCredentials: number;
    totalPendingDocuments: number;
  };
  pendingReviewCount: number;
  styles: { [key: string]: React.CSSProperties };
  showCards?: {
    sucursales?: boolean;
    totalChilitos?: boolean;
    documentosPendientes?: boolean;
    conCredenciales?: boolean;
    pendientesRevision?: boolean;
  };
}

const StatsCards: React.FC<StatsCardsProps> = ({
  data,
  totalStats,
  pendingReviewCount,
  styles,
  showCards = {
    sucursales: true,
    totalChilitos: true,
    documentosPendientes: true,
    conCredenciales: true,
    pendientesRevision: true,
  },
}) => {
  const cards = [];

  if (showCards.sucursales) {
    cards.push(
      <div key="sucursales" style={{ ...styles.statCard, ...styles.statCardBlue, width: "100%", height: "100%" }}>
        <div style={styles.statIconWrapper}>
          <i className="fa-solid fa-building" style={styles.statIcon}></i>
        </div>
        <div style={styles.statContent}>
          <div style={styles.statValue}>{data.length}</div>
          <div style={styles.statLabel}>Sucursales</div>
        </div>
      </div>
    );
  }

  if (showCards.totalChilitos) {
    cards.push(
      <div key="totalChilitos" style={{ ...styles.statCard, ...styles.statCardRed, width: "100%", height: "100%" }}>
        <div style={styles.statIconWrapper}>
          <i className="fa-solid fa-users" style={styles.statIcon}></i>
        </div>
        <div style={styles.statContent}>
          <div style={styles.statValue}>{totalStats.totalPartners}</div>
          <div style={styles.statLabel}>Total Chilitos</div>
        </div>
      </div>
    );
  }

  if (showCards.documentosPendientes) {
    cards.push(
      <div key="documentosPendientes" style={{ ...styles.statCard, ...styles.statCardOrange, width: "100%", height: "100%" }}>
        <div style={styles.statIconWrapper}>
          <i
            className="fa-solid fa-file-circle-exclamation"
            style={styles.statIcon}
          ></i>
        </div>
        <div style={styles.statContent}>
          <div style={styles.statValue}>
            {totalStats.totalPendingDocuments}
          </div>
          <div style={styles.statLabel}>Documentos Pendientes</div>
        </div>
      </div>
    );
  }

  if (showCards.conCredenciales) {
    cards.push(
      <div key="conCredenciales" style={{ ...styles.statCard, ...styles.statCardGreen, width: "100%", height: "100%" }}>
        <div style={styles.statIconWrapper}>
          <i className="fa-solid fa-id-card" style={styles.statIcon}></i>
        </div>
        <div style={styles.statContent}>
          <div style={styles.statValue}>
            {totalStats.partnersWithCredentials}
          </div>
          <div style={styles.statLabel}>Con Credenciales</div>
        </div>
      </div>
    );
  }

  if (showCards.pendientesRevision) {
    cards.push(
      <div key="pendientesRevision" style={{ ...styles.statCard, ...styles.statCardPurple, width: "100%", height: "100%" }}>
        <div style={styles.statIconWrapper}>
          <i
            className="fa-solid fa-clipboard-check"
            style={styles.statIcon}
          ></i>
        </div>
        <div style={styles.statContent}>
          <div style={styles.statValue}>{pendingReviewCount}</div>
          <div style={styles.statLabel}>Pendientes de Revisión</div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.statsGrid}>
      {cards.map((card, index) => (
        <div 
          key={index} 
          style={{ 
            minWidth: 0, 
            maxWidth: "100%",
            display: "flex",
            height: "100%",
          }}
        >
          {card}
        </div>
      ))}
    </div>
  );
};

export default StatsCards;

